import * as t from './actionTypes';
import {
  fetchProjectsRequest,
  fetchProjectsResponse,
  fetchProjectsError,
  updateProjectRequest,
  updateProjectResponse,
  updateProjectError,
} from './actions';
import type { ProjectsReducerState } from './types';

type ProjectsReducerAction = ReturnType<
  | typeof fetchProjectsRequest
  | typeof fetchProjectsResponse
  | typeof fetchProjectsError
  | typeof updateProjectRequest
  | typeof updateProjectResponse
  | typeof updateProjectError
>;

const initialState: ProjectsReducerState['baus']['projects'] = {
  projects: [],
  organizations: [],
  isLoading: false,
};

const projectsReducer = (state = initialState, action: ProjectsReducerAction) => {
  switch (action.type) {
    case t.FETCH_PROJECTS_RESPONSE: {
      return {
        ...state,
        ...action.response,
        isLoading: false,
      };
    }
    case t.UPDATE_PROJECT_REQUEST:
    case t.FETCH_PROJECTS_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.UPDATE_PROJECT_ERROR:
    case t.FETCH_PROJECTS_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default projectsReducer;
